/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const pushCampaignSchema = z.object({
  id: z.number(),
  title: z.string(),
  body: z.string(),
  url: z.string().nullable(),
  audience: z.string(),
  targetUserId: z.string().nullable(),
  tokenCount: z.number(),
  okCount: z.number(),
  failedCount: z.number(),
  createdBy: z.string().nullable(),
  createdAt: z.number(),
});

export type IPushCampaign = z.infer<typeof pushCampaignSchema>;

export const listPushCampaignsV1DataSchema = z.object({
  campaigns: z.array(pushCampaignSchema),
  nextCursor: z.string().nullable(),
});

export type IListPushCampaignsV1Data = z.infer<typeof listPushCampaignsV1DataSchema>;

export const listPushCampaignsV1ResponseSchema = createApiResponseSchema(
  listPushCampaignsV1DataSchema,
) as z.ZodSchema<IAPI<IListPushCampaignsV1Data>>;

export type IListPushCampaignsV1Response = IAPI<IListPushCampaignsV1Data>;
